(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('export-praxedo', {
            parent: 'import',
            url: '/export-praxedo?page&sort&search&name',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.exportPraxedo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/export-praxedo/export-praxedos.html',
                    controller: 'ExportPraxedoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null,
                name:null,
                error:null,
                type:null,
                dateFrom:null,
                dateTo:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        name: $stateParams.name,
                        error: $stateParams.error,
                        type: $stateParams.type,
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exportPraxedo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('export-praxedo-detail', {
            parent: 'export-praxedo',
            url: '/export-praxedo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.exportPraxedo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-detail.html',
                    controller: 'ExportPraxedoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exportPraxedo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExportPraxedo', function($stateParams, ExportPraxedo) {
                    return ExportPraxedo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'export-praxedo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('export-praxedo-detail.edit', {
            parent: 'export-praxedo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.new', {
            parent: 'export-praxedo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                date: null,
                                csv: null,
                                creationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('export-praxedo');
                });
            }]
        })
        .state('export-praxedo.edit', {
            parent: 'export-praxedo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.delete', {
            parent: 'export-praxedo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-delete-dialog.html',
                    controller: 'ExportPraxedoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.newPraxedo', {
            parent: 'export-praxedo',
            url: '/newPraxedo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-newFile-dialog.html',
                    controller: 'ExportPraxedoNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                files: [],
                                typeImport: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('export-praxedo');
                });
            }]
        });
    }

})();
